import React, { useState, useEffect } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Alert, CircularProgress, Grid } from '@mui/material';
import { Add as AddIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import ModuleHub from '../components/ModuleHub';
import { getAccountingPeriods, createAccountingPeriod, updatePeriodStatus, deleteAccountingPeriod } from '../../../services/api';

const AccountingPeriods = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [form, setForm] = useState({ name: '', fiscal_year: new Date().getFullYear(), start_date: '', end_date: '' });

  useEffect(() => { loadData(); }, []);
  const loadData = async () => {
    try { setLoading(true); const r = await getAccountingPeriods(); setItems(r.data || []); }
    catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  const handleSave = async () => {
    try { await createAccountingPeriod(form); setDialogOpen(false); loadData(); }
    catch (err) { setError(err.message); }
  };

  const setStatus = async (id, status) => {
    try { await updatePeriodStatus(id, status); loadData(); }
    catch (err) { setError(err.message); }
  };

  const statusColor = { open: 'success', closed: 'default', locked: 'error' };

  return (
    <ModuleHub moduleId="general-ledger" showFeatures={false}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 2 }}>
        <Button startIcon={<RefreshIcon />} onClick={loadData}>Refresh</Button>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setDialogOpen(true)}>New Period</Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>{error}</Alert>}
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead><TableRow><TableCell>Name</TableCell><TableCell>Fiscal Year</TableCell><TableCell>Start</TableCell><TableCell>End</TableCell><TableCell>Status</TableCell><TableCell>Actions</TableCell></TableRow></TableHead>
            <TableBody>
              {items.map(p => (
                <TableRow key={p.id}>
                  <TableCell><strong>{p.name}</strong></TableCell>
                  <TableCell>{p.fiscal_year}</TableCell>
                  <TableCell>{p.start_date}</TableCell>
                  <TableCell>{p.end_date}</TableCell>
                  <TableCell><Chip label={p.status} size="small" color={statusColor[p.status] || 'default'} /></TableCell>
                  <TableCell>
                    {p.status === 'open' && <Button size="small" onClick={() => setStatus(p.id, 'closed')}>Close</Button>}
                    {p.status === 'closed' && <Button size="small" onClick={() => setStatus(p.id, 'open')}>Reopen</Button>}
                    <Button size="small" color="error" onClick={() => deleteAccountingPeriod(p.id).then(loadData)}>Delete</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>New Accounting Period</DialogTitle>
        <DialogContent><Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}><TextField fullWidth label="Period Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Grid>
          <Grid item xs={4}><TextField fullWidth type="number" label="Fiscal Year" value={form.fiscal_year} onChange={(e) => setForm({ ...form, fiscal_year: parseInt(e.target.value) })} /></Grid>
          <Grid item xs={4}><TextField fullWidth type="date" label="Start Date" InputLabelProps={{ shrink: true }} value={form.start_date} onChange={(e) => setForm({ ...form, start_date: e.target.value })} /></Grid>
          <Grid item xs={4}><TextField fullWidth type="date" label="End Date" InputLabelProps={{ shrink: true }} value={form.end_date} onChange={(e) => setForm({ ...form, end_date: e.target.value })} /></Grid>
        </Grid></DialogContent>
        <DialogActions><Button onClick={() => setDialogOpen(false)}>Cancel</Button><Button variant="contained" onClick={handleSave}>Save</Button></DialogActions>
      </Dialog>
    </ModuleHub>
  );
};

export default AccountingPeriods;
